import { render, staticRenderFns } from "./DhwTemperatureWidget.global.vue?vue&type=template&id=2b1aca8a&scoped=true&lang=pug&"
import script from "./DhwTemperatureWidget.global.vue?vue&type=script&lang=ts&"
export * from "./DhwTemperatureWidget.global.vue?vue&type=script&lang=ts&"
import style0 from "./DhwTemperatureWidget.global.vue?vue&type=style&index=0&id=2b1aca8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1aca8a",
  null
  
)

export default component.exports